import { TextField } from '@material-ui/core';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch, iRootState } from '../redux/store';
import useFormatMessage from '../useFormatMessage';

const FeedbackFromNameEntry = function FeedbackFromNameEntry(): React.ReactElement {
  const from = useSelector((state: iRootState) => state.feedback.fromName);

  const dispatch = useDispatch<Dispatch>();
  const onChange = function handleOnChange(
    event: React.ChangeEvent<HTMLInputElement>
  ): void {
    dispatch.feedback.changeFromName(event.target.value);
  };

  const label = useFormatMessage({
    id: 'yourfullnamerequired',
    defaultMessage: 'Your Full Name (required)'
  });

  return (
    <TextField
      value={from}
      onChange={onChange}
      label={label}
      fullWidth
      variant='outlined'
      margin='dense'
      inputProps={{ maxLength: 100 }}
    />
  );
};

export default FeedbackFromNameEntry;
